import { Text } from '@mantine/core';

import ModalContent from '../ModalContent';

interface Props {
  titleText: string
  bodyText: string
  onConfirm: () => void
  onCancel: () => void
  confirmButtonText?: string
  cancelButtonText?: string
}

const ConfirmationModal: React.FC<Props> = ({
  titleText,
  bodyText,
  onConfirm,
  onCancel,
  confirmButtonText = 'Continue',
  cancelButtonText = 'Cancel'
}: Props) => (
  <ModalContent
    title={titleText}
    onClose={onCancel}
    primaryButton={{
      label: confirmButtonText,
      onClick: onConfirm
    }}
    secondaryButton={{
      label: cancelButtonText,
      onClick: onCancel
    }}
  >
    <Text fz='sm'>{bodyText}</Text>
  </ModalContent>
);

export default ConfirmationModal;
